import { createSlice } from "@reduxjs/toolkit";

export const scheduler_stepper = createSlice({
  name: "scheduler_stepper",
  initialState: {
    value: {
      condition: false,
      stepNumber: 4,
      freight: "Próprio",
    },
  },
  reducers: {
    setCondition(state, { payload }) {
      state.value.condition = payload;
    },
    setStepNumber(state, { payload }) {
      state.value.stepNumber = payload;
    },
    setFreight(state, { payload }) {
      state.value.freight = payload;
    },
  },
});

export const { setCondition, setStepNumber, setFreight } =
  scheduler_stepper.actions;
export default scheduler_stepper.reducer;
